import { initialRoute } from '../model.js';

/**
 * Next handler expects the router instance, and a resolve and reject function
 * as defined by ES5 Promise constructor. If the next handler is invoked with
 * a redirection location (or false) it will reject the promise.
 */
const getNextHandler = (router, resolve, reject) => (to) => {
    switch (typeof to) {
        case 'object':
            router === null || router === void 0 ? void 0 : router.push(to);
            break;
        case 'boolean':
            break;
        default:
            return resolve();
    }
    reject();
};
/**
 * Helper function to generate `forceAuthRestriction` runtime function.
 *
 * Built using ES5 Promise constructor since the resolution must be handled
 * via a callback function passed in memory.
 */
const buildForceAuthRestrictionHelper = (params = {}, routeData, router) => () => new Promise((resolve, reject) => {
    var _a, _b;
    if (!routeData.initialized || !router)
        return reject();
    /**
     * The intention of this function is to force an authentication check
     * using the existing auth restriction logic defined on the front end apps,
     * so we simulate the route meta to include `authRequired: true`.
     */
    const toRoute = { ...routeData.route };
    const metaToSimulate = [toRoute, ...toRoute.matched];
    metaToSimulate.forEach((r) => {
        const route = r;
        route.meta = {
            ...route.meta,
            authRequired: true,
        };
    });
    const fromRoute = (_a = routeData.prevRoute) !== null && _a !== void 0 ? _a : initialRoute;
    (_b = params.allowRoute) === null || _b === void 0 ? void 0 : _b.call(params, toRoute, fromRoute, getNextHandler(router, resolve, reject));
});
/**
 * Helper function to generate the router helpers object.
 *
 * Thus far, this is used to generate the `forceAuthRestriction` helper,
 * which is used to manually reject the current route and redirect to
 * the login page using logic defined on the front end app.
 */
const generateRouterRuntimeHelpers = (params = {}, routeData, router) => {
    const helpers = {};
    if (params.allowRoute) {
        helpers.forceAuthRestriction = buildForceAuthRestrictionHelper(params, routeData, router);
    }
    return helpers;
};

export { generateRouterRuntimeHelpers };
